import SphCheckbox from './Checkbox.vue';

export { SphCheckbox };
export default SphCheckbox;
